<template>
  <f7-block class="">
    <f7-popup
      class="popRep add-new-palet-popup-repro"
      :close-by-backdrop-click="true"
      :opened="popupOpened"
      @popup:closed="popupOpened = false"
    >
      <f7-page>
        <div class="head-popup">
          <f7-row>
            <f7-col width="80">
              <div class="head-text">
                {{ $t('commercialization.picking.labels.packagingTypeReprocessed') }}
              </div>
            </f7-col>
            <f7-col width="20">
              <div class="head-btn">
                <f7-button
                  popup-close
                >
                  <img
                    alt="iconCancel"
                    src="@/static/icons/ic_cancel_dark.svg"
                  >
                </f7-button>
              </div>
            </f7-col>
          </f7-row>
        </div>
        <div class="display-flex flex-direction-column  container-searchs">
          <f7-row class="margin-top">
            <f7-col>
              <UCSearchEntityERP
                ref="UCProductFamily"
                :title="$t('searchEntity.productFamily.title.productFamily').toUpperCase()"
                :placeholder="$t('searchEntity.productFamily.placeholder.selectAProductFamily')"
                :search-text="$t('searchEntity.productFamily.searchText')"
                :search-cancellation-text="$t('searchEntity.productFamily.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.productFamily.searchNotFoundText')"
                :disabled="familyProductDisable"
                :emit-evet-change-default-value="true"
                :end-point-for-list="GetProductFamily"
                :end-point-for-code-search="GetProductFamilyCodeSearch"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventselectedProductFamily"
              />
            </f7-col>
            <f7-col>
              <UCSearchEntityERP
                ref="UCProduct"
                :title="$t('common.product').toUpperCase()"
                :placeholder="$t('searchEntity.product.placeholder.selectAProduct')"
                :search-text="$t('searchEntity.product.searchText')"
                :search-cancellation-text="$t('searchEntity.product.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.product.searchNotFoundText')"
                :default-value="orderLineSelected != null ? orderLineSelected.LineaPedidoVenta.InfoProducto : null"
                :emit-evet-change-default-value="true"
                :end-point-for-code-search="GetProductCodeSearch"
                :end-point-for-list="GetProductList"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :disabled="productDisable"
                @selection="EventselectedProduct"
              />
              <!-- @selection="(value) => typePackagingReprocessed.Producto = value" -->
            </f7-col>
          </f7-row>
          <f7-row class="margin-top">
            <f7-col>
              <UCSearchEntityERP
                ref="UCEnvase"
                :title="$t('common.package').toUpperCase()"
                :placeholder="$t('searchEntity.container.placeholder.selectAContainer')"
                :search-text="$t('searchEntity.container.searchText')"
                :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                :default-value="orderLineSelected != null ? orderLineSelected.LineaPedidoVenta.InfoEnvase : null"
                :emit-evet-change-default-value="true"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :end-point-for-code-search="GetEnvaseCodeSearch"
                :end-point-for-list="GetContainerList"
                @selection="(value) => typePackagingReprocessed.Envase = value"
              />
            </f7-col>
            <f7-col>
              <UCSearchEntityERP
                ref="UCPale"
                :title="$t('common.pallet').toUpperCase()"
                :placeholder="$t('searchEntity.pallet.placeholder.selectAPallet')"
                :search-text="$t('searchEntity.pallet.searchText')"
                :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
                :emit-evet-change-default-value="true"
                :disabled="disablePaleType"
                :default-value="orderLineSelected != null ? orderLineSelected.LineaPedidoVenta.InfoPale : null"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :end-point-for-code-search="GetPaleCodeSearch"
                :end-point-for-list="GetPaleList"
                @selection="(value) => typePackagingReprocessed.Pale = value"
              />
            </f7-col>
          </f7-row>
          <f7-row class="margin-top">
            <f7-col>
              <UCSearchEntityERP
                ref="UCMarca"
                :title="$t('common.brand').toUpperCase()"
                :placeholder="$t('searchEntity.brand.placeholder.selectABrand')"
                :search-text="$t('searchEntity.brand.searchText')"
                :search-cancellation-text="$t('searchEntity.brand.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.brand.searchNotFoundText')"
                :default-value="orderLineSelected != null ? orderLineSelected.Marca : null"
                :emit-evet-change-default-value="true"
                :property-entity-shown-input="['Nombre']"
                :property-entity-shown-list-title="['Nombre']"
                :min-text-search="0"
                :end-point-for-code-search="GetMarkCodeSearch"
                :end-point-for-list="GetMarkList"
                @selection="(value) => typePackagingReprocessed.Marca = value"
              />
            </f7-col>
            <f7-col>
              <UCSearchEntityERP
                ref="UCLineaProduccion"
                :title="$t('common.productionLine').toUpperCase()"
                :placeholder="$t('searchEntity.line.placeholder.selectProductionLine')"
                :search-text="$t('searchEntity.line.searchText')"
                :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
                :min-text-search="0"
                :emit-evet-change-default-value="true"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :default-value="lineaProduccionDefectoLocal"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :end-point-for-code-search="GetProductionLineCodeSearch"
                :end-point-for-list="GetProductionLineList"
                @selection="(value) => typePackagingReprocessed.LineaProduccion = value"
              />
            </f7-col>
          </f7-row>
          <f7-row class="margin-top">
            <f7-col>
              <div class="margin-left-half margin-top-half">
                <span>
                  {{ $t('common.packagesPerPallet').toUpperCase() }}
                </span>
              </div>
              <div class="content-input">
                <input
                  type="Number"
                  :value="initialPackagesInputValue"
                  inputmode="numeric"
                  :placeholder="$t('common.quantity')"
                  @change="typePackagingReprocessed.EnvasesPorPale = $event.target.value"
                >
              </div>
            </f7-col>
            <f7-col>
              <UCSearchEntityERP
                ref="UCUbicacionDestino"
                :title="$t('searchEntity.location.title.targetLocation').toUpperCase()"
                :placeholder="$t('searchEntity.location.placeholder.selectATargetLocation')"
                :search-text="$t('searchEntity.location.searchText')"
                :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
                :min-text-search="0"
                :default-value="ubicacionDefectoEntradaLocal"
                :emit-evet-change-default-value="true"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :end-point-for-code-search="GetUbicacionCodeSearch"
                :end-point-for-list="GetDestinationLocation"
                @selection="(value) => typePackagingReprocessed.UbicacionDestino = value"
              />
            </f7-col>
          </f7-row>
        </div>
        <div class="popup-add-palet-footer">
          <div>
            <f7-row>
              <f7-col>
                <f7-button
                  class="btn-popup-cancel"
                  popup-close
                  @click="Cancel"
                >
                  {{ $t('common.cancel') }}
                </f7-button>
              </f7-col>
              <f7-col>
                <f7-button
                  class="btn-popup-confirm"
                  @click="Confirm"
                >
                  {{ $t('common.confirm') }}
                </f7-button>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </f7-block>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';

import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA, {
  callObtenerArticulos,
  callObtenerFamiliasDeArticulos,
  callObtenerMarcas,
} from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { TipoArticulo } from '@/js/common/enum';
import { deepToRaw } from '@/js/utils/deepToRaw';

/** @import { ConfeccionReprocesado } from '@erpagroapp/types' */

export default {

  name: 'PCPopupTypePackagingReprocessed',
  components: {
    UCSearchEntityERP,
  },
  props: {
    orderLine: { type: Object, default: null },
    disablePaleType: { type: Boolean, default: false },
  },

  emits: ['confirm'],

  data() {
    return {
      popupOpened: false,
      typePackagingReprocessed: /** @type {ConfeccionReprocesado} */ ({}),
      familyProduct: null,
      productDisable: false,
      familyProductDisable: null,
      orderLineSelected: null,
      ubicacionDefectoEntradaLocal: null,
      lineaProduccionDefectoLocal: null,
      ubicacionDefectoEntrada: useParamRef('UbicacionDefectoEntrada'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'lineasDeProduccionDelUsuarioDefinidaEnERP',
    ]),

    initialPackagesInputValue() {
      return this.orderLineSelected?.LineaPedidoVenta?.EnvasesPorPalet;
    },
  },
  watch: {
    orderLine(val) {
      this.orderLineSelected = val;
    },
    disablePaleType(val) {
      if (val) {
        this.$refs.UCPale.Clear();
      }
    },
    ubicacionDefectoEntrada(val) {
      this.ubicacionDefectoEntradaLocal = val ? structuredClone(deepToRaw(val)) : null;
    },
  },

  mounted() {
    Log(this, 'PCPopupTypePackagingReprocessed->mounted');
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.orderLineSelected = this.orderLine;
      this.typePackagingReprocessed.EnvasesPorPale = this.initialPackagesInputValue;

      this.ubicacionDefectoEntradaLocal = this.ubicacionDefectoEntrada ? structuredClone(deepToRaw(this.ubicacionDefectoEntrada)) : null;
      this.lineaProduccionDefectoLocal = this.lineasDeProduccionDelUsuarioDefinidaEnERP;

      if (this.disablePaleType) {
        this.$refs.UCPale.Clear();
      }
    },

    /**
     * @public
     * @returns {void}
     */
    Show() {
      Log(this, this.Show.name);
      // this.StartComponent();
      this.popupOpened = true;
    },
    ValidateForm() {
      Log(this, this.ValidateForm.name);
      if (!this.typePackagingReprocessed.Producto) {
        HiNotification.Toast(this.$t('common.needToSelectAProduct'));
        return false;
      }
      if (!this.typePackagingReprocessed.Envase) {
        HiNotification.Toast(this.$t('common.needToSelectAPackage'));
        return false;
      }
      if (!this.disablePaleType && !this.typePackagingReprocessed.Pale) {
        HiNotification.Toast(this.$t('common.needToSelectAPallet'));
        return false;
      }

      /*
      if (!this.typePackagingReprocessed.Marca) {
        HiNotification.Toast('Es necesario seleccionar una marca');
        return false;
      }
      */

      if (this.typePackagingReprocessed.EnvasesPorPale < 1) {
        HiNotification.Toast(this.$t('commercialization.picking.info.needToSellectPackagesQuantity'));
        return false;
      }
      if (!this.typePackagingReprocessed.LineaProduccion) {
        HiNotification.Toast(this.$t('common.needToSelectAProductionLine'));
        return false;
      }
      if (!this.typePackagingReprocessed.UbicacionDestino) {
        HiNotification.Toast(this.$t('common.needToSelectADestinationLocation'));
        return false;
      }
      return true;
    },
    Confirm() {
      Log(this, this.Confirm.name);
      if (!this.ValidateForm()) {
        return false;
      }
      this.$emit('confirm', this.typePackagingReprocessed);
      this.popupOpened = false;
      return true;
    },

    Cancel() {
      Log(this, this.Cancel.name);
      this.$refs.UCProductFamily.Clear();
      this.$refs.UCLineaProduccion.Clear();
      this.$refs.UCUbicacionDestino.Clear();
      this.$refs.UCProduct.SelectEntity(this.orderLineSelected.LineaPedidoVenta.InfoProducto, true);
      this.$refs.UCEnvase.SelectEntity(this.orderLineSelected.LineaPedidoVenta.InfoEnvase, true);
      this.$refs.UCPale.SelectEntity(this.orderLineSelected.LineaPedidoVenta.InfoPale, true);
      if (this.orderLineSelected.Marca === null) {
        this.$refs.UCMarca.Clear();
      } else {
        this.$refs.UCMarca.SelectEntity(this.orderLineSelected.Marca, true);
      }
      if (this.ubicacionDefectoEntradaLocal === null) {
        this.$refs.UCUbicacionDestino.Clear();
      } else {
        this.$refs.UCUbicacionDestino.SelectEntity(this.ubicacionDefectoEntradaLocal, true);
      }
      if (this.lineaProduccionDefectoLocal === null) {
        this.$refs.UCLineaProduccion.Clear();
      } else {
        this.$refs.UCLineaProduccion.SelectEntity(this.lineaProduccionDefectoLocal, true);
      }
    },
    EventselectedProductFamily(value) {
      Log(this, this.EventselectedProductFamily.name);
      if (value != null) {
        this.familyProduct = value.Id;
        this.productDisable = false;
      } else {
        this.productDisable = true;
      }
    },
    EventselectedProduct(value) {
      Log(this, this.EventselectedProduct.name);
      this.typePackagingReprocessed.Producto = value;

      if (value != null) {
        this.productDisable = false;
        this.familyProductDisable = true;
      } else {
        this.productDisable = true;
        this.familyProductDisable = false;
      }
    },

    GetProductFamilyCodeSearch(params) {
      Log(this, this.GetProductFamilyCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerFamiliaDeArticulosPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },

    GetPaleCodeSearch(params) {
      Log(this, this.GetPaleCodeSearch.name);
      return new Promise((resolve, reject) => {
        callObtenerArticulos({
          tipoArticulo: TipoArticulo.Palet,
          codigoArticulo: params,
        }).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },

    GetMarkCodeSearch(params) {
      Log(this, this.GetMarkCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerMarcaPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },

    GetProductionLineCodeSearch(params) {
      Log(this, this.GetProductionLineCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerLineaDeProduccionPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },

    GetEnvaseCodeSearch(params) {
      Log(this, this.GetEnvaseCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerArticulosDeTipoEnvasePorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    GetUbicacionCodeSearch(params) {
      Log(this, this.GetUbicacionCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUbicacionPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetProductList() {
      Log(this, this.GetProductList.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerArticulosMateriaPrimaDeUnaFamilia(this.familyProduct).then((result) => { // TODO
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    GetProductCodeSearch(params) {
      Log(this, this.GetProductCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerArticulosDeTipoProductoPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetContainerList() {
      Log(this, this.GetContainerList.name);
      return new Promise((resolve, reject) => {
        callObtenerArticulos({ tipoArticulo: TipoArticulo.Envase }).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },

    async GetPaleList() {
      Log(this, this.GetPaleList.name);
      return new Promise((resolve, reject) => {
        callObtenerArticulos({ tipoArticulo: TipoArticulo.Palet }).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetMarkList() {
      Log(this, this.GetMarkList.name);
      return new Promise((resolve, reject) => {
        callObtenerMarcas().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetProductionLineList() {
      Log(this, this.GetProductionLineList.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerLineasDeProduccion().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetDestinationLocation() {
      Log(this, this.GetDestinationLocation.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUbicaciones().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetProductFamily() {
      Log(this, this.GetProductFamily.name);
      return new Promise((resolve, reject) => {
        callObtenerFamiliasDeArticulos().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.head-popup {
  background: #dfe1e5;
}

.head-btn {
  width: 50px;
  height: 50px;
  float: right;
}

.head-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--his-steel-blue);
  margin-top: 15px;
  margin-left: 15px;
}

.popup-add-palet-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.popup-search {
  width: 350px;
  height: 35px;
  margin-left: 25px;
}

.searchPale {
  height: 75px;
}

.btn-popup-cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #c1c1c1;
  width: 150px;
}

// estilos popup añadir nuevo palet reprocesados

.add-new-palet-popup-repro {
  width: 774px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -300px;
  margin-left: -387px;
  border-radius: 4px;

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .btn-popup-confirm {
    float: right;
    width: 150px;
  }

  .container-searchs {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
